var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FormAddBusinessAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { FormsBusinessDTO } from "../constanst/FormsBusinessDTO";
export var AddBusinessView = function (props) {
    var _a, _b, _c;
    return (_jsx(FormAddBusinessAFY, __assign({}, FormsBusinessDTO, { filters: props.filters, damageBackup: props.damageBackup, insuredProperty: props.insuredProperty, dataForm: props.dataFormBusiness, propertyTypeList: props.businessType, ProvinceList: (_a = props.provinceList) !== null && _a !== void 0 ? _a : [], TownList: (_b = props.townList) !== null && _b !== void 0 ? _b : [], SectorList: (_c = props.sectorList) !== null && _c !== void 0 ? _c : [], businessShiftList: props.businessShift, typeConstructionList: props.typeConstruction, onClickCalculateRate: function (data) {
            return props.onCalculateRate(data, {
                productCode: props.productCode,
                planCode: props.planCode,
            });
        }, onChangeCheckBox: function (e, data) {
            props.onSameDirection(e, data);
        }, onChangeNumberValue: function noRefCheck() { }, onChangeSelect: props.onChangeSelect, onClickCancel: props.handleClickPrevious, onNext: props.onClickNext, disableNextButton: props.disableNextButton })));
};
